import { useLoaderData, LoaderFunction } from 'react-router';
import { useEffect, useState } from 'react';
import CarouselSlideShow from '~/components/carousel/slideshow';
import CoFinancingLogo from '~/components/cofinancing';
import LoginStandard from '~/components/login/standard';
import { getSession } from '~/sessions';
import { useTranslation } from 'react-i18next';
import { SESSION_STORAGE_KEY, AV_ENABLED_KEY } from '~/components/ai/ai-sidebar';

export const loader: LoaderFunction = async ({ request }) => {
    const session = await getSession(request.headers.get('Cookie'));
    if (session.get('userId')) {
        return { shouldRedirect: true };
    }
    return { shouldRedirect: false };
};

export default function Login() {
    const { t } = useTranslation();
    const [twoFactorAuthActive, setTwoFactorAuthActive] = useState(false);
    const { shouldRedirect } = useLoaderData<{
        shouldRedirect: boolean;
    }>();

    // Session ended — clear any leftover AI conversation state
    useEffect(() => {
        sessionStorage.removeItem(SESSION_STORAGE_KEY);
        sessionStorage.removeItem(AV_ENABLED_KEY);
    }, []);

    useEffect(() => {
        if (shouldRedirect) {
            window.location.href = '/Home';
        }
    }, [shouldRedirect]);

    if (shouldRedirect) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                }}
            >
                <span className="loading-xl loading loading-spinner"></span>
                <p>{t('auth.redirectingHome')}</p>
            </div>
        );
    }

    return (
        <div
            className="relative flex h-screen w-full flex-col [@media(min-width:1024px)]:flex-row [@media(min-width:1024px)]:items-stretch"
            id="loginContainer"
        >
            {/* Login Container */}
            <div
                id="leftColumn"
                className="relative z-20 flex min-h-screen w-full flex-col bg-transparent pb-24 md:pb-0 [@media(min-width:1024px)]:w-1/2 [@media(min-width:1024px)]:bg-white"
            >
                <div className="flex flex-1 items-center justify-center">
                    <div
                        className="relative mx-auto w-[95%] max-w-md sm:w-11/12 md:w-10/12 lg:w-9/12"
                        id="formLoginContainer"
                    >
                        {/* standard login component */}
                        <LoginStandard
                            twoFactorAuthActive={twoFactorAuthActive}
                            setTwoFactorAuthActive={setTwoFactorAuthActive}
                        />
                    </div>
                </div>

                {/* Desktop: (visível só em >=md) */}
                <div
                    id="CoFinancingLogoContainer"
                    className="absolute bottom-16 left-1/2 z-20 w-full max-w-[20rem] -translate-x-1/2 sm:max-w-[20rem] md:bottom-12 md:max-w-[28.625rem] lg:max-w-[28.625rem]"
                >
                    <div className="flex h-auto w-full items-center justify-center px-4">
                        <CoFinancingLogo className="h-auto w-full" />
                    </div>
                </div>
            </div>

            {/* Carousel Container */}
            <div
                id="rightColumn"
                className="absolute inset-0 z-0 flex h-full w-full flex-col [@media(min-width:1024px)]:relative [@media(min-width:1024px)]:z-0 [@media(min-width:1024px)]:w-1/2"
            >
                <CarouselSlideShow />
            </div>
        </div>
    );
}
